
<template>
    <div class="container">
        <div class="flex-center">
            「<div class="ellipsisText ellipsisTitleWidth">{{ nickName }}</div> 」 的收货信息
        </div>
        <div v-if="list.length > 0" class="scroll">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了~" @load="onLoad"
                :immediate-check="false">
                <div v-for="item in list" :key="item.id">
                    <van-swipe-cell>
                        <div class="flex_address">
                            <div class="flex">
                                <div @click="onEdit(item)" style="color: #969799;">
                                    <van-icon name="edit" size="20" />
                                </div>
                                <div style="padding: 0 16px;" class="ellipsisTextDesc">
                                    <span>
                                        <span style="font-size: 12px;">{{ item.cellPhone }}</span>
                                    </span>
                                    <div style="margin-top: 8px;color: #919191;font-size: 12px;">
                                        {{ item.province + item.city + item.district + item.details }}
                                    </div>
                                </div>
                            </div>
                            <div @click="onConfirm(item)" style="color: #EE0A24;">
                                选择
                            </div>
                        </div>
                        <template #right>
                            <van-button square text="删除" type="danger" class="delete-button" @click='onDelete(item)' />
                        </template>
                    </van-swipe-cell>
                </div>
            </van-list>
        </div>
        <van-dialog v-model="close" confirmButtonText="我知道了" cancelButtonColor="#9c9c9c" @confirm="close = false"
            v-if="AgentIsShow">
            <div class="flexCenter" style="padding: 32px 42px;font-size: 14px;flex-wrap: wrap;">
                <div>您正在为「</div>
                <div class="ellipsisText ellipsisDisabledWidth">{{ agentShow.address.nickName }}</div>
                <div>」代买{{activeText}}</div>
            </div>
        </van-dialog>
        <div class="noAgents" v-if="list.length == 0">
            <div class="nullPage">
                <img src="../../../assets/images/update.png" alt />
            </div>
            <div class="noAgentText">还没有代买人收货信息哦~</div>
        </div>
        <div class="bottomBackground">
            <van-button type="danger" class="bottomBtn" @click="onAdd">新增收货信息</van-button>
        </div>
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import {
    AddressList,
    Toast,
    Cell,
    Panel,
    Icon,
    Tag,
    Button,
    List,
    PullRefresh,
    Overlay,
    Dialog,
    SwipeCell
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/buyAgent";
import loading from "../../components/loading/loading";
export default {
    components: {
        [AddressList.name]: AddressList,
        [Toast.name]: Toast,
        [Cell.name]: Cell,
        [Panel.name]: Panel,
        [Icon.name]: Icon,
        [Tag.name]: Tag,
        [Button.name]: Button,
        [List.name]: List,
        [PullRefresh.name]: PullRefresh,
        [Overlay.name]: Overlay,
        [Dialog.Component.name]: Dialog.Component,
        [SwipeCell.name]: SwipeCell,
        loading
    },
    data() {
        return {
            activeText:'',
            close: false,
            nickName: '',
            isLoading: true, //loading状态
            chosenAddressId: "1",
            list: [],
            disabledlist: [],
            defaultAddress: {},
            AgentId: '',
            page: 1,
            pageSize: 20,
            loading: false,
            finished: false,
            refreshing: false
        };
    },
    computed: {
        ...mapGetters(["userInfo", "agentShow"]),
        AgentIsShow() {
            return this.agentShow == null ? false : this.agentShow.isShow;
        },
    },
    methods: {
        ...mapActions(["updateUserCartQuantity", "buyAgentStatus"]),
        // 编辑
        onEdit(item) {
            console.log(this.AgentIsShow, item.id == this.agentShow.id, item, this.agentShow, 119)
            if (this.AgentIsShow == true && item.id == this.agentShow.address.id) {
                this.close = true
                this.activeText = '不可编辑'
            } else {
                this.$router.push({
                    name: "buyAgentedit",
                    query: { id: item.id, type: "update" }
                });
            }

        },
        // 代买
        onConfirm(item) {
            console.log(item, 115)
            var a = {
                address: item,
                show: true
            }
            //选中地址存起来 
            this.buyAgentStatus(a)
            this.$router.push('page')
        },
        init() {
            this.page = 1;
            this.addressList().then((addressList) => {
                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
                if (addressList.items.length !== 0) {
                    this.list = addressList.items;
                    if (addressList.totalCount <= 8) {
                        this.finished = true;
                        this.loading = false;
                    } else {
                        this.onLoad();
                    }
                } else {
                    this.list = [];
                    this.defaultAddress.isDefault = false;
                }
            }).catch(err => {
                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
            });
        },
        onLoad() {
            this.page++;
            this.loading = true;
            this.addressList().then((addressList) => {
                this.list = this.list.concat(addressList.items);
                this.loading = false;
                if (addressList.totalCount <= this.list.length) {
                    this.finished = true;
                } else {
                    this.onLoad()
                }
            });
        },
        addressList() {
            return new Promise((resolve, reject) => {
                service
                    .agentList(this.AgentId, this.page, this.pageSize)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject();
                    });
            });
        },

        onAdd() {
            this.$router.push({
                name: "buyAgentedit",
                query: { id: this.AgentId, type: "add" }
            });
        },
        onDelete(info) {
            if (this.AgentIsShow == true && info.id == this.agentShow.address.id) {
                this.close = true
                this.activeText = '不可删除'
            } else {
                Dialog.confirm({
                    message: "确认删除么"
                })
                    .then(() => {
                        service
                            .deleteAddress(info.id)
                            .then((res) => {
                                if (res.statusCode == 200) {
                                    Toast("删除成功");
                                    this.init();
                                }
                            })
                            .catch((err) => {
                                Toast(err);
                            });
                    })
                    .catch(() => {
                        Toast("你已取消删除");
                    });
            }
        }
    },
    mounted() {
        this.AgentId = this.$route.query.id
        this.nickName = this.$route.query.name
        this.init();
    }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    // position: fixed;
    // height: calc(100% - 12.7vw);
    min-height: 100vh;
    font-size: 14px;

    .buyAgentTitle {
        color: #343434;
    }

    .van-overlay {
        z-index: 1000;
    }

    .top {
        border-bottom: 1px solid #f7f7f7;
    }

    .addresslistEmpty {
        .van-cell--center {
            padding: 4.66667vw 4.26667vw;
        }
    }

    .scroll {
        height: calc(100% - 2.3vw);
        overflow-y: auto;
        padding-bottom: 19.4vw;
    }

    .delete-button {
        height: 100%;
    }

    .flex-center {
        height: 48px;
        background-color: #fff;
        margin-bottom: 8px;
        color: #000;
    }
}

.flex_address {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 16px;
    border-bottom: 1px solid #e6e6e6;
    justify-content: space-between;
    // height: 44px;
}
</style>